/// <amd-module name="VSSUI/Callout" />
export { Callout } from "./Components/Callout/Callout";
export { ContentLocation, ContentJustification, ContentOrientation, ContentSize, ICallout, ICalloutProps } from "./Components/Callout/Callout.Props";
